import addSeconds from 'date-fns/addSeconds';
import isBefore from 'date-fns/isBefore';
export var isDateOlderThanSeconds = function (date, seconds) {
    return isBefore(addSeconds(date, seconds), new Date());
};
export default isDateOlderThanSeconds;
